module.exports = __webpack_public_path__ + "static/media/Outdoors.1821c78f.webp";